import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { designSystem } from '@yola/ws-ui';
import OptionSection from 'src/js/modules/common/components/option-section';
import { INDETERMINATE } from '../constants';
import optionTypes from '../constants/option-types';
import ElementSettingsContext from '../helpers/element-settings-context';
import getOptionComputedAttributesValues from '../helpers/get-option-computed-attributes-values';

const { Box, ActionRadioGroup } = designSystem;

const boxPaddings = {
  paddingTop: 'spacing-xs',
  paddingLeft: 'spacing-m',
  paddingRight: 'spacing-m',
  paddingBottom: 'spacing-xs',
};

function ActionRadioGroupOption({ option, settingId, onUpdateValue }) {
  const { state, callbacks } = useContext(ElementSettingsContext);

  const attributesValues = getOptionComputedAttributesValues(state, option).flat();
  const selectedValue = attributesValues[0];

  const isIndeterminate = !attributesValues.every((value) => value === selectedValue);
  const selectedId = isIndeterminate
    ? INDETERMINATE
    : option.choices.find((choice) => choice.value === selectedValue)?.id;

  const paddingProps = !option.isSubOption ? boxPaddings : {};

  const handleChange = (opt) => {
    onUpdateValue(opt.value);
    callbacks.onOptionClicked({ optionId: option.id, settingId });
  };

  return (
    <Box {...paddingProps}>
      <OptionSection title={option.title} popoverProps={option.popover} bold={!option.isSubOption}>
        <ActionRadioGroup
          options={option.choices}
          selectedId={selectedId}
          onChange={handleChange}
        />
      </OptionSection>
    </Box>
  );
}

ActionRadioGroupOption.propTypes = {
  option: PropTypes.shape({
    id: PropTypes.string.isRequired,
    type: PropTypes.oneOf(Object.values(optionTypes)).isRequired,
    elementIds: PropTypes.arrayOf(PropTypes.string),
    attributes: PropTypes.arrayOf(PropTypes.string),
    choices: PropTypes.array,
    title: PropTypes.string,
    isSubOption: PropTypes.bool,
    component: PropTypes.element,
    popover: PropTypes.shape({
      title: PropTypes.string,
      imgSrc: PropTypes.string,
    }),
    computeFallbackValue: PropTypes.func,
  }).isRequired,
  settingId: PropTypes.string.isRequired,
  onUpdateValue: PropTypes.func.isRequired,
};

export default ActionRadioGroupOption;
